import { render } from "./ConformitySettings.vue?vue&type=template&id=59738354&scoped=true"
import script from "./ConformitySettings.vue?vue&type=script&lang=js"
export * from "./ConformitySettings.vue?vue&type=script&lang=js"

import "./ConformitySettings.vue?vue&type=style&index=0&id=59738354&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59738354"]])

export default __exports__